<template>
  <div class="lxm-activity-detail">
    <header>
      <router-link :to=toFeedbackPage>
      <h3 class="activity-title"> {{ activityDetail.title }} </h3>
      </router-link>
      <section class="basic-info">
        <p class="duration" v-if="activityHasDuration"> {{ activityDuration }} </p>
        <p class="address"> {{ activityAddress }} </p>
      </section>
    </header>
    <section class="sign-info">
      <router-link :to=toFeedbackPage>
          <p class="sign-up-count">总报名人数 <span class="count"> {{ activityDetail.signed_up_user_count }} </span></p>
          <p class="sign-in-count">签到人数 <span class="count"> {{ activityDetail.current_session_time_sign_in_count }} </span>
            <span class="session-time"> {{ activityDetail.current_session_time_sign_in.name }} </span> </p>
          <div class="lxm-activity-detail__right-arrow"></div>
      </router-link>
    </section>
    <section class="qr-code-scan">
      <div class="qr-code-wrapper">
          <label for="sign-up-code-input" class="sign-up-code-label">
            签到  <span class="scan-tips">点击 <i class="scan-icon">1</i> 可以扫描二维码进行签到 </span>
          </label>
          <div class="control is-grouped qr-code-row">
            <div class="control sign-up-code has-addons">
              <input id="sign-up-code-input" class="input is-expanded"
                     type="number" v-model="signInCode"
                     v-on:keyup="submitGetSignUp()"
                     ref="input"
                     placeholder="请输入票号或手机号">
            </div>
              <button id="qr-code-scan-button" class="button qr-code-scan-button"
                      v-show="canUseScanQrCode"
                      @click="scanQRCode()"></button>
              <button id="sign-up-code-submit" class="submit-button button is-info is-outlined is-rounded"
                      v-show="!canUseScanQrCode"
                      @click="submitGetSignUp()">确定</button>
          </div>
      </div>
    </section>
    <sign-up v-if="activitySignUp"
             v-bind:activityDetail="this.activityDetail"
    />

    <qr-code-scanner v-if="qrcodeModalVisible" @scan-code-result="scanCodeResult"></qr-code-scanner>

  </div>
</template>

<style lang="stylus" scoped>
@import '../../styles/index.styl'
.lxm-activity-detail
  position absolute
  width 100%
  background-color #fff
  padding 1rem
header
.activity-title
  font-weight 600
  font-size 1.4rem
  text-align center
.basic-info
  padding 0.8rem 0 1rem 0
  color grey
  font-size 1rem
  font-weight 600
  line-height 1.6rem
.sign-info
  border-width 1px 0
  border-style solid
  border-color white-line
  a
    display block
    height 100%
  p
    font-size 1rem
    padding-left 2rem
    line-height 3.6rem
    display inline-block
    color #000
    span.count
      color brand-primary
      font-weight 800
      font-size 1.2rem
    span.session-time
      color: grey
.lxm-activity-detail__right-arrow
  background-image url(../../images/main/contact/item-right-arrow.png)
  background-size 100% 100%
  float right
  margin-top 1rem
  width 1rem
  height 1.4rem
.scan-tips
  font-weight normal
  font-size 0.8rem
  color grey
.qr-code-scan
  padding 1rem 0
.qr-code-wrapper
  font-size 1.2rem
  width 100%
  position relative
.qr-code-row
  padding 0.6rem 0
#sign-up-code-submit
  font-size 1.2rem
  width 4rem
  height 3rem
  display inline-block
  background-color #fff
  border 1px solid brand-primary
  color brand-primary

.sign-up-code
  font-size 0
  width 85%
.qr-code-input
  font-size 1rem
  font-weight 600
  border-color grey-dark
#qr-code-scan-button
  height 3rem
  width 3rem
  border none
  background-size contain
  background-image url("https://s.lingxi360.com/mobile/img/scan1scan.png")
  background-repeat no-repeat
#sign-up-code-input
  height 3rem
  font-weight 800
  border-radius 10px
  &::placeholder
    font-weight normal
    font-size 0.8rem
#sign-up-code-input:focus
  border-color #676767
.scan-icon
  display inline-block
  width 1rem
  height 1rem
  color transparent
  background-size cover
  background-image url("https://s.lingxi360.com/mobile/img/scan1scan.png")
</style>

<script>
  import LxmNav from '../common/LxmNav.vue'
  import SignUp from './SignIn'
  import { DateTime } from 'luxon'
  import * as aTypes from '../../../store/action-types'
  import * as mTypes from '../../../store/mutation-types'
  import api from '../../../api'
  import QrCodeScanner from './QrCodeScanner.vue'

  export default {
    components: {
      QrCodeScanner,
      'lxm-nav': LxmNav,
      'sign-up': SignUp
    },
    props: {
      activityId: String,
      openScanQRCode: Boolean
    },
    beforeRouteLeave (to, from, next) {
      if (this.pollingActivityCountId) {
        clearInterval(this.pollingActivityCountId)
      }
      if (to.query.activityId !== this.activityDetail.id) {
        this.$store.commit(mTypes.ACTIVITY_RESET_SIGN_UP)
      }
      next()
    },
    beforeDestroy () {
      this.stopScanner()
    },
    data () {
      return {
        signInCode: '',
        pollingActivityCountId: null,
        localWxReady: false,
        html5QrCode: null,
        canUseCameras: false
      }
    },
    computed: {
      wxReady () {
        // console.log('computed wechat ready is: ', this.$store.state.wechatJsReady)
        return this.$store.state.wechatJsReady
      },
      activityDetail () {
        return this.$store.state.activity.detail
      },
      activitySignUp () {
        return this.$store.state.activity.loaded
      },
      activityHasDuration () {
        return Number(this.activityDetail.signin_start_time) > 0 &&
          Number(this.activityDetail.signin_end_time) > 0
      },
      activityDuration () {
        if (!this.activityHasDuration) {
          return ''
        }
        const n = 'numeric'
        const d2 = '2-digit'
        const l = 'long'
        // 最小化的格式, 开始至少有日期时间, 结束至少有时间, 其余字段根据逻辑加入
        let startFormat = {
          month: l,
          day: n,
          hour: d2,
          minute: d2
        }
        let endFormat = {
          hour: n,
          minute: d2
        }
        const now = DateTime.local(undefined)
        const start = DateTime.fromSeconds(this.activityDetail.signin_start_time).setLocale('zh-cn')
        const end = DateTime.fromSeconds(this.activityDetail.signin_end_time).setLocale('zh-cn')
        const endSameYear = start.hasSame(end, 'year')
        const endSameDay = start.hasSame(end, 'day')
        if (!start.hasSame(now, 'year')) {
          startFormat = Object.assign(startFormat, { year: n })
        }
        if (!endSameDay) {
          endFormat = Object.assign(endFormat, { month: l, day: n })
        }
        if (!endSameYear) {
          endFormat = Object.assign(endFormat, { year: n })
        }
        return start.toLocaleString(startFormat) + '-' + end.toLocaleString(endFormat)
      },
      activityAddress () {
        return this.activityDetail.address_city + this.activityDetail.address_area + this.activityDetail.address
      },
      toFeedbackPage () {
        return {
          name: 'activityFeedback',
          query: {
            activityId: this.activityId
          }
        }
      },
      qrcode () {
        return this.$store.state.activity.qrcode
      },
      qrcodeModalVisible () {
        return this.$store.state.activity.qrcodeModalVisible
      },
      canUseScanQrCode () {
        return this.canUseCameras || this.wxReady
      }
    },
    mounted () {
      // console.log('wx js ready', this.$store.state.wechatJsReady)
      this.$store.state.navTitle = '签到'
      // 清空之前的签到信息
      this.$store.commit(mTypes.ACTIVITY_RESET_SIGN_UP)
      // 加载七牛配置
      this.loadQiniuConfig()
      this.fetchActivity().then(() => {
        this.pollingActivityCountId = this.pollingActivityCount()
      })
      // 如果有 ticketNo 参数，自动填入并请求接口
      if (this.$route.query.ticketNo) {
        this.signInCode = this.$route.query.ticketNo
        this.$nextTick(() => {
          this.submitGetSignUp()
        })
      }
      if (this.wxReady) {
        if (this.openScanQRCode) {
          this.scanQRCode()
        }
      } else {
        this.isCanUseCamera().then(() => {
          if (this.openScanQRCode) {
            this.scanQRCode()
          }
        })
      }
    },
    watch: {
    },
    methods: {
      scanCodeResult () {
        this.signInCode = this.qrcode
        // 使用后清空
        this.$store.commit(mTypes.ACTIVITY_SET_SCAN_QRCODE, '')
        this.submitGetSignUp()
      },
      loadQiniuConfig () {
        api.qiniu.getConfig({
          success: (res) => {
            if (res.body) {
              this.$store.commit(mTypes.SET_QINIU_CONFIG, res.body)
            }
          }
        })
      },
      fetchActivity () {
        return this.$store.dispatch(aTypes.ACTIVITY_GET_DETAIL, {
          activityId: this.activityId
        })
      },
      pollingActivityCount () {
        return setInterval(() => {
          this.$store.dispatch(aTypes.ACTIVITY_GET_COUNT, {
            activityId: this.activityId
          })
        }, 5000)
      },
      scanQRCode () {
        if (!this.canUseScanQrCode) {
          return false
        }
        // 先用微信
        if (this.wxReady) {
          new Promise((resolve, reject) => {
            window.wx.scanQRCode({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
              success: resolve,
              fail: reject
            })
          }).then(res => {
            this.signInCode = res.resultStr
            return this.$store.dispatch(aTypes.ACTIVITY_GET_SIGN_UP, {
              activityId: this.activityId,
              number: this.signInCode
            })
          })
        } else if (this.canUseCameras) {
          this.$store.commit(mTypes.ACTIVITY_SET_SCAN_QRCODE_MODAL_VISIBLE, true)
        }
      },
      submitGetSignUp () {
        const length = this.signInCode.toString().length
        if (length === 11 || length === 10) {
          return this.$store.dispatch(aTypes.ACTIVITY_GET_SIGN_UP, {
            activityId: this.activityId,
            number: this.signInCode
          })
        }
      },
      stopScanner () {
        if (this.html5QrCode) {
          this.html5QrCode.stop().then(() => {

          }).catch(() => {

          })
        }
      },
      isCanUseCamera () {
        return new Promise((resolve, reject) => {
          if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
            navigator.mediaDevices.enumerateDevices().then(devices => {
              const cameraDevices = devices.filter(device => device.kind === 'videoinput')

              if (cameraDevices.length > 0) {
                this.canUseCameras = true

                resolve(true)
              } else {
                this.canUseCameras = false
                resolve(false)
              }
            }).catch(() => {
              this.canUseCameras = false
              resolve(false)
            })
          } else {
            this.canUseCameras = false
            resolve(false)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Detail.vue?7db667aa